import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

type FileInputProps = {
  handleChange: (file: File | null) => void;
  allowedFileTypes: string[];
};

const FileInput = ({ handleChange, allowedFileTypes }: FileInputProps) => {
  const { t } = useTranslation();

  const [file, setFile] = useState<any>(null);
  const [inputKey, setInputKey] = useState(Date.now()); // unique key

  useEffect(() => {
    if (file) {
      handleChange(file);
    } else {
      handleChange(null);
    }
  }, [file]);

  const clearFile = () => {
    setFile(null);
    setInputKey(Date.now()); // trigger re-render of input
  };

  return (
    <Box>
      <Button
        variant="outlined"
        component="label"
        fullWidth
        sx={{ mb: "10px", py: 3, justifyContent: "flex-start", minHeight: 60 }}
        size="large"
        color="inherit"
        endIcon={
          file && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                // Clear the file input
                clearFile();
              }}
              size="small"
            >
              <Close />
            </IconButton>
          )
        }
      >
        {file ? file.name : t("Select a file")}
        <input
          key={inputKey} // forces re-creation on key change
          type="file"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              setFile(file); // Pass the File object
            }
          }}
          accept={allowedFileTypes.map((ext) => `.${ext}`).join(", ")}
        />
      </Button>

      {/* <Fade in={pdfFileError !== ""} unmountOnExit mountOnEnter>
        <Alert severity="warning">{pdfFileError}</Alert>
      </Fade> */}
    </Box>
  );
};

export default FileInput;
